import type { EmployeurDTO } from '@/features/api/extranet/dto/Demande/AF'
import { addPreBuilder, type Flag, type Regles } from '@/features/domaine/moteur-regles'
import { LevelRegleEnum } from '@/features/domaine/types/opco/shared'

import type { CarDTO } from '@/features/api/extranet/dto/Demande/CAR'
import type { FichierDTO } from '@/features/api/extranet/dto/Demande/shared'
import type { EtablissementAdherentDTO } from '@/features/api/extranet/dto/shared'
import { PropertyStatus } from '../../property-status'
import {
  isAdherentOuMandatGestion,
  rgEstMailFactory,
  rgEstMaxLengthFactory,
  rgEstNumTelFactory,
  rgEstObligatoireFactory,
  rgEstVraiFactory,
} from '../shared'
import { SAISIE_OBLIGATOIRE } from '../shared/messages-erreurs'
import type { ContextReglesCar, ReglesCar } from './types'

// /* Initalisation des helpers */
const addPre = addPreBuilder<CarDTO, ContextReglesCar>()

/* Declaration de type pour les sous modeles */
type RegleCarMembre<T extends object> = Regles<T, ContextReglesCar, LevelRegleEnum, Flag, CarDTO>

/* Etablissement */
const reglesEtablissementEmployeur: RegleCarMembre<EtablissementAdherentDTO> = {}

/* Employeur */
const reglesEmployeur: RegleCarMembre<EmployeurDTO> = {
  etablissement: reglesEtablissementEmployeur,

  contact: {
    email: {
      ...rgEstMaxLengthFactory(200),
      ...addPre(
        (_value, _parent, _model, context) =>
          context.status.employeur?.contact?.email?.$status === PropertyStatus.Required,
        rgEstObligatoireFactory(LevelRegleEnum.Transmettre),
      ),
      ...rgEstMailFactory(LevelRegleEnum.Metier),
    },
    telephone: {
      ...rgEstMaxLengthFactory(10),
      ...addPre(
        (_value, _parent, _model, context) =>
          context.status.employeur?.contact?.telephone?.$status === PropertyStatus.Required,
        rgEstObligatoireFactory(LevelRegleEnum.Transmettre),
      ),
      ...rgEstNumTelFactory(LevelRegleEnum.Metier),
    },
  },
}

/* Fichiers */
const reglesFichiers: RegleCarMembre<FichierDTO> = {}

/* REGLES  ------------------------------------------------------------------------ */
export const reglesConfiguration: ReglesCar = {
  validationNotice: {
    ...rgEstVraiFactory(LevelRegleEnum.Transmettre),
  },
  attestationPiecesJustificatives: {
    ...addPre(
      (_value, _parent, _model, context) =>
        context.status.attestationPiecesJustificatives?.$status === PropertyStatus.Required,
      {
        ...rgEstVraiFactory(LevelRegleEnum.Transmettre),
      },
    ),
  },

  attestationSurHonneur: {
    ...rgEstVraiFactory(LevelRegleEnum.Transmettre),
  },
  acceptationCg: {
    ...rgEstVraiFactory(LevelRegleEnum.Transmettre),
  },

  employeur: reglesEmployeur,

  fichiers: reglesFichiers,

  $model: {
    controleFichier: {
      validateur: (model, _globalModel, context) => {
        if (!isAdherentOuMandatGestion(context.typeContext, false)) return

        for (const doc of context.naturesFichiers.obligatoires) {
          if (model.fichiers?.some((x) => x.nature === doc) !== true) return { fichiers: false }
        }
      },
      message: SAISIE_OBLIGATOIRE,
      level: LevelRegleEnum.Transmettre,
    },
  },
} as const
